/**
 * 组件信息
 */
export const info = {
  name: 'xy-activity-marquee', // 组件名
  type: 'component-business', // 组件类型
  label: '活动跑马灯', // 组件label
  icon: 'icon-xy-marquee', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 80 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  // 文本内容
  content: {
    type: Array,
    default: [{
      img: 'https://meta-oss.evkland.cn/user/portrait/dev/367427/user_head.jpg',
      message: 'hello world!!'
    }]
  },
  // 动画延迟时间
  delay: { type: Number, default: 0.5 },
  // 动画速度
  speed: { type: Number, default: 100 },
  direction: { type: String, default: 'horizontal' }, // 'horizontal' 或 'vertical'
  // 水平滚动时的具体方向
  scrollDirection: { type: String, default: 'rtl' } // 新增滚动方向属性，默认为从右往左 'rtl' | 'ltr'
}


/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-activity-marquee',
    label: '内容列表', // 表单名称
    propKey: 'content', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  }
]
